import { Container, Flex } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../Sidebar/Sidebar';

export default function AdminMain() {
  return (
    <Container p={0} maxW="100%" minH="100vh" bg="background.primary" display="flex">
      <Flex w="100%">
        <AdminSidebar />
        <Outlet />
      </Flex>
    </Container>
  );
}
